const homepage = document.querySelector('[data-template^="index"]');

if (homepage && homepage.dataset.homepageAnalyticsReady !== 'true') {
  homepage.dataset.homepageAnalyticsReady = 'true';

  const inferredEvents = [
    ['a[href="#shop-by-place"]', 'hero_find_place'],
    ['a[href="#what-we-make"]', 'hero_what_we_make'],
    ['a[href*="/collections/featured"]', 'hero_most_loved'],
    ['.cp-gifts-feature a[href*="/collections/greeting-cards"], .cp-format-grid a[href*="/collections/greeting-cards"]', 'gift_cards_click'],
    ['.cp-gifts-feature a[href*="/collections/magnets"], .cp-format-grid a[href*="/collections/magnets"]', 'gift_magnets_click'],
    ['.cp-business-services a[href*="/pages/wholesale"]', 'wholesale_click'],
    ['.cp-business-services a[href*="/pages/custom-drone-photography"]', 'drone_click'],
    ['.cp-review-widget a[href]', 'reviews_source_click'],
    ['main a[href="/pages/about"]', 'about_nick_click'],
  ];

  const publish = (eventName, value) => {
    if (!eventName) return;

    const detail = { event: eventName };
    if (value) {
      if (eventName === 'location_click') detail.location_handle = value;
      else if (eventName === 'reviews_source_click') detail.source = value;
      else if (eventName === 'newsletter_submit') detail.form_location = value;
      else detail.destination = value;
    }

    window.dispatchEvent(new CustomEvent('cornwallprints:analytics', { detail }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(detail);
  };

  if (new URLSearchParams(window.location.search).get('customer_posted') === 'true') {
    publish('newsletter_submit', 'footer');
  }

  homepage.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || !homepage.contains(link)) return;

    const explicitTarget = link.closest('[data-homepage-event]');
    if (explicitTarget?.dataset.homepageEvent) {
      publish(
        explicitTarget.dataset.homepageEvent,
        explicitTarget.dataset.homepageValue || link.getAttribute('href'),
      );
      return;
    }

    const productList = link.closest('[data-list-analytics-event]');
    if (productList?.dataset.listAnalyticsEvent && link.closest('product-card')) {
      publish(productList.dataset.listAnalyticsEvent, new URL(link.href, window.location.origin).pathname);
      return;
    }

    const match = inferredEvents.find(([selector]) => link.matches(selector));
    if (match) publish(match[1], link.getAttribute('href'));
  });
}
